export default __webpack_public_path__ + "static/media/gear-icon.032fbb98.svg";